<template>
  <div class="car-hardware">
    <div class="row">
      <div class="col-sm-6">
        <p class="h4"><strong>Serial:</strong> {{ box.serial }}</p>
        <p class="h4"><strong>Version:</strong> {{ box.version }}</p>
        <p class="h4"><strong>Provider:</strong> {{ box.provider }}</p>
      </div>
      <div class="col-sm-6">
        <h4>Currently in used by:</h4>
        <template v-if="box.Car">
          <p class="h4">{{ box.Car.dropdownLabel }}</p>
          <img :src="carImage"/>
        </template>
        <template v-else>Not in use</template>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link class="btn btn-default" :to="{ path: `/hardware/boxes/edit/${box.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarHardware',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.box.Car.CarType.AmazonImage.objectKey
    },
    box () {
      return {
        Car: {
          name: '',
          CarType: {
            AmazonImage: {
              objectKey: 'spacer.gif'
            }
          }
        },
        ...this.object
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/CarHardware.vue